import axiosInstance from '../lib/axios-instance';

export const getFile = async ({
  filePath,
  view,
}: {
  filePath: string;
  view: 'inline' | 'attachment';
}): Promise<Blob> => {
  const queryParams = new URLSearchParams({
    filePath,
    view,
  });
  try {
    const res = await axiosInstance.get(`file?${queryParams}`, {
      responseType: 'blob',
    });

    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error('Failed to get file');
  }
};
